/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/statistics.scss";
import Tab from "../../component/Inc/Tab";
import LineChart from "../../component/Inc/LineChart";

function DemonstrationLecture() {
  const lineChartWidth = "100%";
  const lineChartHeight = "200px";

  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    { title: "월별", value: 0 },
    { title: "담임 별", value: 1 },
  ];

  //Linechartlabels
  const lineChartlabels = [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월",
  ];

  //demonstration lecture data by Month
  const lineChartDataMonth = {
    lineChartlabels,
    datasets: [
      {
        label: "요청 수",
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: "#d1cdca",
        borderWidth: 1,
        backgroundColor: "#fc8019",
      },
      {
        label: "성공",
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: "#d1cdca",
        borderWidth: 1,
        backgroundColor: "#3780ff",
      },
    ],
  };

  //demonstration lecture data by Teacher
  const lineChartDataTeacher = {
    lineChartlabels,
    datasets: [
      {
        label: "요청 수",
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: "#d1cdca",
        borderWidth: 1,
        backgroundColor: "#fc8019",
      },
      {
        label: "성공",
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: "#d1cdca",
        borderWidth: 1,
        backgroundColor: "#3780ff",
      },
    ],
  };

  return (
    <main className="com_container p_demonstration_lecture">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_6">시범강의 성공률</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full ">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />

              <section className="com_board_search">
                <article className="search">
                  <input
                    type="search"
                    placeholder="검색할 내용을 입력해 주세요."
                    className="input s type_search"
                  />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>

            <hr className="com_divider" />

            <div className="com_count_wrapper">
              <div className="req_lect">
                <div className="req_label">
                  <span className="req_title">총 시범강의 요청 수</span>
                  <span className="req_value">98,798</span>
                </div>
              </div>
              <div className="suc_lect">
                <div className="suc_label">
                  <span className="suc_title">총 시범강의 요청 수</span>
                  <span className="suc_value">46500,000(24%)</span>
                </div>
              </div>
              <div className="turnover">
                <div className="turnover_label">
                  <span className="turnover_count">총 매출액</span>
                  <span className="turnover_value">46,500,000</span>
                </div>
              </div>
            </div>

            {/* demonstration lecture by month */}
            {tabIdx === 0 && (
              <div className="month_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">요청 수</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">성공</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart
                        data={lineChartDataMonth}
                        width={lineChartWidth}
                        height={lineChartHeight}
                      />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>1월</th>
                      <th>2월</th>
                      <th>3월</th>
                      <th>4월</th>
                      <th>5월</th>
                      <th>6월</th>
                      <th>7월</th>
                      <th>8월</th>
                      <th>9월</th>
                      <th>10월</th>
                      <th>11월</th>
                      <th>12월</th>
                      <th>합계</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>요청 수</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>성공 수</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td>150,000</td>
                      <td className="td_point">4568,000</td>
                    </tr>
                    <tr>
                      <td>성공률(%)</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td>12</td>
                      <td className="td_point">45%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {/* demonstration lecture by teacher */}
            {tabIdx === 1 && (
              <div className="teacher_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">요청 수</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">성공</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart
                        data={lineChartDataTeacher}
                        width={lineChartWidth}
                        height={lineChartHeight}
                      />
                    </div>
                  </div>
                </div>
                <div className="check">
                  <input
                    type="radio"
                    name="rdo"
                    id="rdo01"
                    className="com_chk circle"
                  />
                  <label htmlFor="rdo01">전체</label>
                  <input
                    type="radio"
                    name="rdo"
                    id="rdo02"
                    className="com_chk circle"
                  />
                  <label htmlFor="rdo02">시범강의 요청 수</label>
                  <input
                    type="radio"
                    name="rdo"
                    id="rdo03"
                    className="com_chk circle"
                  />
                  <label htmlFor="rdo03">시범강의 성공 수</label>
                </div>
                <table className="com_board_list type_row_big">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        <button className="arrow active" />
                        No
                      </th>
                      <th>
                        <button className="arrow active" />
                        담임명
                      </th>
                      <th>
                        <button className="arrow active" />
                        1월
                      </th>
                      <th>
                        <button className="arrow active" />
                        2월
                      </th>
                      <th>
                        <button className="arrow active" />
                        3월
                      </th>
                      <th>
                        <button className="arrow active" />
                        4월
                      </th>
                      <th>
                        <button className="arrow active" />
                        5월
                      </th>
                      <th>
                        <button className="arrow active" />
                        6월
                      </th>
                      <th>
                        <button className="arrow active" />
                        7월
                      </th>
                      <th>
                        <button className="arrow active" />
                        8월
                      </th>
                      <th>
                        <button className="arrow active" />
                        9월
                      </th>
                      <th>
                        <button className="arrow active" />
                        10월
                      </th>
                      <th>
                        <button className="arrow active" />
                        11월
                      </th>
                      <th>
                        <button className="arrow active" />
                        12월
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>7</td>
                      <td>김홍보305</td>
                      <td className="td_point td_left">
                        64567
                        <br /> 324
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td className="td_point td_left">
                        64567
                        <br /> 324
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr className="summarized_rows">
                      <td rowSpan="2" className="border_right">
                        2023
                      </td>
                      <td className="td_point">시범강의 요청수</td>
                      <td className="td_point">3124</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td className="td_point">시범강의 요청수</td>
                      <td className="td_point">3124</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                      <td className="td_point">64567</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td rowSpan="2" className="border_right">
                        2022
                      </td>
                      <td>시범강의 요청수</td>
                      <td>3124</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td>시범강의 요청수</td>
                      <td>3124</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                      <td>64567</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
}

export default DemonstrationLecture;
